<template>
  <div id="code-editor" class="w-full">
    <div id="tabs">
      <div
        id="html-tab"
        @click="selectEditingTab('html')"
        class="tab"
        :class="{ 'active': selectedTab === 'html' }"
      >
        HTML
      </div>
      <div
        id="css-tab"
        @click="selectEditingTab('css')"
        class="tab"
        :class="{ 'active': selectedTab === 'css' }"
      >
        CSS
      </div>
      <div
        id="js-tab"
        @click="selectEditingTab('js')"
        class="tab"
        :class="{ 'active': selectedTab === 'js' }"
      >
        JS
      </div>
    </div>
    <div id="editor">
      <div class="h-full flex flex-col justify-between relative" :style="[mode_exam ? {'pointer-events': 'none', 'opacity':'0.4'} : '']">
        <template v-for="(file, key) in files">
          <VueMonaco :key="key"
            :file="file"
            :firebaseUid="firebaseUid"
            :userColor="userColor"
            :readOnly="readOnly"
            class="code-monaco"
            :style="{ 'z-index': selectedTab === file.code ? 999 : -999 }"
            @preview="$emit('preview', $event)"
          />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import VueCodemirror from '@/components/Snippets/VueCodemirror.vue'
import VueMonaco from "./VueMonaco"
export default {
  name: 'CodeEditorComponent',
  components: {
    VueCodemirror,
    VueMonaco
  },
  props: {
    files: Array,
    mode_exam: Boolean,
    firebaseUid: String,
    userColor: String,
    readOnly: Boolean
  },
  data() {
    return {
      selectedTab: 'html'
    }
  },
  methods: {
    selectEditingTab(tab) {
      this.selectedTab = tab
    }
  }
}
</script>

<style scoped lang="scss">
#editing {
  #files {
    .tab-file {
      border-bottom: 2px solid transparent;
      color: var(--text-light);
      transition: all .3s;

      &.tab-html {
        #icon-html {
          color: #d45632;
        }

        &.active {
          border-color: #d45632;
        }
      }

      &.tab-css {
        #icon-css {
          color: #2652dc;
        }

        &.active {
          border-color: #2652dc;
        }
      }

      &.tab-js {
        #icon-js {
          color: #f0db4f;
        }

        &.active {
          border-color: #f0db4f;
        }
      }

      &.active {
        color: var(--text-white);
        background-color: var(--bg-input);
      }
    }
  }

  #code {
    .tab-code {
      display: none;

      &.active {
        display: block;
      }
    }
  }
}
</style>
